import { sidebarName_en } from "./sidebarName";
import { about_en } from "./aboutInfo";

export default {
    sidebarName: sidebarName_en,
    about: about_en,
    chatArea: 'Chatting Room',
    send: 'Send',
    delete: 'Delete',
    deletenotes: 'Click to delete sub. a/c',
    audience: 'visitors',
    stopTalkTips: 'After clicking，a message will sent a inform to the guests to remind them end the neogtiation within 10 minutes',
    talkInviteTips: 'After clicking, the system will find the person who is queuing up for the current period and automatically send him / her an invitation to negotiate',
    stopTalk: 'stop talking',
    endTalk: 'End Chatting',
    beginTalk: 'Start',
    endForum: 'end',
    beginForum: 'begin',
    permissionDenied: 'no permission for microphone, camera. pls get permission.',
    ask: 'question',
    HTC: "MANUAL",
    forgotPwd: "Forget Password",
    agree: 'agree ',
    findPwd: "Reset Password",
    exit: 'Exit',
    talkEnded: 'talk ended ',
    forumEnded: 'forum ended',
    endTalkByAnchor: 'exhibitor has ended the talk',
    addToBlacklist: 'you are blacklisted',
    cancelAsk: 'questions-asking cancel ed',
    askReject: 'your questioning is rejected',
    askAgree: 'you can ask questions now',
    endAsk: 'questioning ended',
    addBlacklist: 'to be blacklisted',
    whiteboard: 'whiteboard',
    uploadFile: 'upload file',
    uploadSuccess: 'Upload successful',
    uploadFail: 'Upload failed',
    uploadProgress: 'Upload progress:',
    uploadVideoMax: 'The upload video cannot be larger than 50m',
    uploadFileMax: 'The upload file cannot be larger than 10m',
    joinLiveFail: 'Miss connecting',
    joinLiveSuccess: 'Join successfully',
    uploadPic: 'Uploading pictures',
    uploadFiles: 'Uploading files',
    uploadFilesFormat: 'File format not supported',
    trancodingFailure: 'Transcoding failure',
    uploading: 'Uploading, current progress:',
    transcodingTask: 'Create transcoding task',
    waitTranscodingTask: 'Queuing for transcoding',
    transcoding: 'In transcoding, current progress:',
    transcodingFinish: 'Transcoding complete',
    microphoneClose: 'turns off the microphone',
    microphoneOpen: 'turns on the microphone',
    cameraClose: 'turns off the camera',
    cameraOpen: 'turns on the camera',
    file: 'File',
    fileManage: 'View the File',
    appendixManage: 'Upload/Download',
    video: 'Video',
    inputPlease: 'Input your message..',
    title: 'title English',
    exhibition: "HOME",
    loginSuccess: "Log in successfully",
    registerSuccess: "register successful ",
    payError: "pay error",
    search: "Search",
    details: "Details",
    packUp: "pack up",
    userInfo: "My Account",
    login: "LOGIN",
    loadingLogin: "you are now loging in",
    register: " REGISTER",
    // english: "CHINESE ",
    english: "中文",
    explain: "System operating instructions",
    exhibitionState: "Status Of The Fair",
    createSuccessful: "creation successful",
    seats: "seats",
    state0: "All",
    state1: "Pending ",
    state2: "On-going",
    state3: "Ended",
    or: "or",
    promptMessage:"You have not logged in or registered, cannot make an appointment!",
    toggelSubjectMessage:"Unable to make an appointment if no reservation time is set.",
    registerArea1:"International ",
    registerArea2:"Overseas ",

    exState: "IN PROMOTION",
    exState1: "MAKING AN APPOINTMENT",
    exState2: "ON-GOING",
    exState3: "ENDED",

    exhibitionSelect: "Please select ",
    exhibitionName: "EXHIBITION NAME",
    participation: "Participate",
    exhibitionVisit: "Visit",
    exhibitionSignup:"Register",
    ticketsTips1:"Dear {0}, you have just bought {1}, are you going to buy more?",
    ticketsTips2:"{0} visitor ticket",
    ticketsTips3:"{0} exhibitor tickets",
    exhibitionPay:"Pay",
    sellAd:"Advertisement",
    site: "booth",
    site1: "ticket",
    joinVenue: "Enter",
    exhibitionTime: "Exhibition Time",
    exhibitionIntroduce: "introduction ",
    cluesTime1: "In",
    cluesTime2: "days",
    cluesTime3: "hours ",
    day: "Day",
    loginPrompt: "Please enter email",
    password: "Password",
    client: "Client",
    bbsVisitor: "Visitor",
    peopleSeat: "seat/booth",
    accountLogin: "Account Login",
    ticketsLogin: "Ticket Login",
    banks: "Ticket No.",
    username: "User Name",
    username2: "Name",
    gender:"Gender",
    phone: "Phone number",
    ticketNumber: "Please enter the ticket number",
    inputName: "Your name",
    inputPhone: "Please input email",
    phoneLoginRules: "Not empty",
    inputCode: "Please Input code",
    setPwd: "Set Password",
    reqPwd: "Repeat Password",
    verificationCode: " Security Code",
    sendVerificationCode: "Get Code",
    toResend: "To resend",
    oneToOne: "Online Booth",
    originalPassword: 'Original Password',
    newPassword: 'New Password',
    confirmPassword: 'Verify Password',
    enterOriginalPassword: 'please enter original password',
    enterYourPassword: 'please ender your password',
    passwordAgain: 'pass word again',
    samePassword: 'same as the original password!',
    twoPassinconsistent: ' two passwords inconsistant!',
    to: "to",
    error: "No Data",
    playback: "Play Back",
    playbacknotes: "Click to watch live playback",
    talkCompany: "talk company",
    talkCompanynotes: "Click on the audience list",
    forumCompany: "Record",
    forumCompanynotes: "View the negotiated companies list",
    copyTic: "copy",
    zhang: "sheet",
    buyTicketNumbers: "ticket numbers",
    watch: "Watch",
    newWatch: "View",
    date: "date",
    forum: "Forum",
    userInfoRules: "Full information ",
    passwordRules: " Full password ",
    ticketRules: "Not empty",
    usernameRules: "Not empty",
    phoneRules: "phone not empty",
    codeRules: "Not empty",
    phoneCorrectlyRules: "Please enter the correct mobile phone number",
    userRules: "username not empty",
    userCorrectlyRules: "6-20 characters and Numbers",
    passwordCorrectlyRules: "The password should be 6-20 characters in letters, Numbers, or symbols (except Spaces)",
    emailRules: "Not empty",
    emailCorrectlyRules: "Please enter the correct email address",
    protocol: "I have read the ",
    nickName: "Name",
    talkBtn: "Chatting Now",
    underNegotiation: "Talking",
    talkBtnnotes: "Click to chat now",
    newTalkBtn: "Let's talk",
    guestscompany: "Company",
    guestscompanyName: "Company Name",
    guestsBusiness: "Main business",
    guestsLocation: "Region",
    companyName: "Company Name",
    subiectTime:"Acceptable booking time",
    subiectTimeTips: "Please select Acceptable booking time",
    indexSou:'Company name / Region / Business classification / Key word',
    regInputPhone: "Your Phone Number",
    home: "Country",
    userPost: "Job Title",
    businessInfo: " Main business",

    email: "Email",
    contact: "Contact",
    contact2: "Phone",
    contact3: "Phone No",
    companyNameRules: "Not empty ,max 100 characters",
    homeRules: "Not empty, max 100 characters",
    trueNameRules: "Not empty，max 5 characters",
    jobRules: "Not empty, max 60 characters",
    logout: "Logout",
    marked: "Exit the current user?",
    hitDown: "Click the 'Download' button to download the highest version of Chrome",
    leaveDown: "Please go to Chrome and enter the studio",
    hold: "The stdudio function does not support this browser to run,",
    hint: "Hint",
    tips: "TIPS",
    endNegotiateTip: "Remind the attendee that the meeting will come to an end.",
    hour: "hour",
    aboutUs: "ABOUT US",
    blueBusiness: "BUSINESS",
    forwarderConference: "Forwarder conference",
    GlobalShippingSummit: "Global shipping summit",
    InternationalFreightFair: "International Freight FAIR",
    setToHomePage: "SET TO HOMEPAGE",
    shippingNetwork: "SHIPPING CHINA",
    allRightsReserved: "",
    internationalization: "The 9th China International Freight Forwarding Annual Conference and international freight exhibition",
    startTime: "Nov. 2nd-3rd, 2020",
    exhService: "Service Center",
    serveTel: "",
    sponsor: "Organizer, WIFFA ",
    localPlace: "Dalian International Conference Center, Hilton Dalian Fuli",
    scanQR: "Scan the code to learn more",
    local: "location",
    offlineEvent: " off line exhibition",
    business: "Cloud Exhibition",

    aboutExh: "About US",
    contactPeople: "Contact",
    advertisingAttract: "AD. Promotion",
    overseasInvestment: "For Overseas",
    FAE: "Technical Support",
    exhAttract: " For Domestic",
    telNumber: "Phone number",
    exhTel: "Contact Us",
    platform: "Customer Service Center",
    card: "Business Cards",
    makeCard: "13000+ Contact NOW",
    extend: "",
    cloud: "Online Transactions Platform",
    vip: "WIFFA Network",
    directories: "110 cities in China",
    know: "1200+ members",
    customerPhone: "Tel. No.:",
    license: " License No.",
    internetRecord: "Internet Record No.",
    confirm: "Confirm",
    findInput: "Email",
    cancel: "Cancel",
    exitSuccess: "Log out successfully",
    applet: "APPLET",
    pleaseEnterPwd: "Set up your password",
    pleaseAgainEnterPwd: "Set up your password Again",
    save: "Save",
    saveInfonotes: "Click to save the modified content",
    savePwdnotes: "Click Save to submit password modification",
    edit: "edit",
    enter: "Enter",
    enternotes: "Enter the corresponding Exhibition",
    buy: "Confirm",
    buyTicket: "buy ticket",
    balance: "Balance",
    recharge: "Recharge",
    //Personal center module
    personal: ' Information',
    exhibitionRecord: 'Record',
    ParticipationRecord: 'Record',
    myTicket: 'My ticket',
    subaccountManagement: 'Sub Account',
    studioManagement: 'Studio Booth',
    appointment:'Schedule',
    appointmentnotes:'Set your time available',
    keyword:'keyword',
    changePassword: 'Reset Password',
    createBBS: 'Create a BBS',
    create: "create",
    visitorTickets: 'Tickets',
    ticketsExhibition: 'Meeting Rooms',
    oneTone: 'One to one',
    bbs: 'BBS',
    accountId: 'Account ID',
    mobilePhone: 'Cell Phone',
    overtime: "login timeout, please login again",
    getInMyTicket: 'you may check in your ticket ',
    getInMyTicket1: 'You can check it out from the guest seats',
    name: 'Name',
    ticName: 'Exhibition Name',
    hintContact: " Contact",
    classification: 'Business Type',
    accountError: "you can not invite others",
    personalTextPrompt:'Please perfect your personal information in Both Chinese and English',
    //我的门票/观展门票 My ticket/visitors' tickets
    fairName: 'Name',
    forumName: 'Business Theme',
    fairTime: 'Time',
    ticfairTime: 'Fair Time',
    price: 'Rate',
    buyTime: 'Payment Time',
    operation: 'Operation',
    state: "Status",
    playbackList: "play back list",
    //我的门票/参展门票 My tickets/exhibitors' tickets
    ticketsTypes: 'Type',
    role: 'role',
    sms: "SMS",
    //直播间管理 Studio management
    bbsName: 'bbsName',
    studioFairName: 'Studio Booth Name/Fair Name',
    LiveRoomShowTip: 'If you need additional Studio Booth, please contact the administrator. \nContact information:overseas@wiffaorg.net',
    //观展记录 visitors record
    studioName: 'Studio Booth Name',
    broadcastType: 'Type',
    seeContact: "display contact",
    lineUp: "I have to line up",
    lineUpOn: "I've lined up",
    helpfulHints: " Tips!",
    helpfulHints2: " Please add a sub-account first before Allocate.",
    notLogin: "Please login or register",
    notLogin2: "Please login or register",
    notLogin3: " Click log in",
    nologinInstructions:"You haven't logged in yet.",
    paymentMethod: "Please select.",
    buyWatchTickets: "buy watch-tickets to watch the war",
    buyExhibitionTickets: "Purchase of Tickets",
    onlineBuy: "Online Purchase",
    offlineBuy: "Offline Purchase",
    free: "free",
    total: "Total",
    weChat: "WeChat",
    payTreasure: "Alipay",

    CNY: "CNY",
    rates: "ticket prices",
    see: "see",
    leave: "leave",
    buyTicketNumber: "",
    PCS: "pc",
    oneSeat: "1 seats",
    twoSeat: "2 seats",
    threeSeat: "3 seats",
    sum: "total",
    haveRead: "I have read",
    ticketAgreement: "ticket protocol",
    wxPay: "WeChat pay",
    offlinePay:"Bank Information",
    payMoney: "",
    scan: "scan",
    scanPay: "Scan QR code",
    backPay: "Choose other payment methods",
    guest: "Guest",
    compere: "Host",
    compereCh: "Host(CN)",
    compereEn: "Host(EN)",
    chineseName: "(CN)",
    englishName: "(EN)",
    segmentation: 'To divide by; divide',
    time: "Time",
    notData: "Empty Data",
    watchReplay: "Watch The Replay",
    regSuccess: "Registered successfully",
    codeSendSuccess: "The Verification Code Was Sent To The Mailbox",
    codeError: "The mailbox has been registered, pls choose another one",
    ticText: "Invite into Live Streaming",
    ticTextTwo: "Once the exhibition started, the rooms allocated can not be re-assigned",
    editExh: "Booth Setting",
    editExhnotes: "Complete your info",
    enterExh: "Enter",
    addRoom: "Add Room",
    enterExhnotes: "Click to enter the studio booth",
    enterExhltnotes: "Click to enter the studio booth",
    giving: "Allocate",
    givingTitle: "Allocate Rooms",
    givingnotes:"Click to allocate",
    recycling: "Re-assigned",
    // recyclingnotes: "",
    buyOffInfo: "For offline purchase, please contact 04198258323 for details",
    liveClass: "Services Category",
    addChildAccount: "Add Sub Account",
    addChildAccountnotes: "Click to add sub. Account",
    childAccount: 'Choose a sub account',
    bbsTheme: "bbs theme",
    bbsThemeCh: "bbs theme(CN)",
    bbsThemeEn: "bbs theme",
    bbsThemeChTips: "please enter Meeting Topic(CN)",
    bbsThemeEnTips: "please enter Meeting Topic",
    userPostChTips: "please enter Job Title(CN)",
    userPostEnTips: "please enter Job Title",
    truenameChTips: "please enter Name(CN)",
    truenameEnTips: "please enter Name",
    keyWordsChTips: "please enter business key Words(CN)",
    keyWordsEnTips: "please enter business key Words",
    companyLogoTips: "please select logo",
    contactTips: "please enter Phone No",
    classTips: "please select business type",
    bbsForumAccount: "Total number of Live broadcast",
    bbsForumLive: "Live broadcast ongoing",
    bbsForumNowNum: "Total number of Live broadcast at present",
    bbsTime: "bbs time",
    bbsTimeCh: "bbs time(CN)",
    bbsTimeEn: "bbs time(EN)",
    introduction: "Introduction",
    introductionCh: "Introduction(CN)",
    introductionEn: "Introduction(EN)",
    companyLogo: "Logo",
    applentLogo: "Applet sharing logo",
    enterUserId: "Email/ID/Mobile",
    addSubaccount: "Add Sub Account",
    add: "add",
    exhSeat: "exhibition seat ",
    subaccountText: "The person being invited need to register in this meeting before you add sub account. Please enter his/her account ID or mobile phone or email address.",
    areYouSuretoDelete: "confirm the deletion",
    icon: "email",
    lineWait: "line up",
    wait: "There is a negotiation in the studio, please wait in line",
    deal: " agreement",
    usageTitle: "The system supports PC brower only",
    chrome: "The latest version of chrome is recommended",
    down: "Click to download Chrome",
    appletCode: "applet QR code",
    weChatCode: "WeChat scan the QR code",
    room: "Studio Support",
    exhibitor: "Exhibitors using the latest version of chrome",
    visitor: "Visit the show using the latest version of the Chrome",
    addSub: "You do not have a sub-account, please add first.",
    goAdd: "Continue",
    giveSuccess: "give success",
    fileMaxSize: "file max size 2M",
    editSuccess: "edition success",
    delSuccess: "deletion success",
    addSuccess: "add success",
    youLine: "Are you in line",
    canEnter: "The studio is now accessible",
    into: "into",
    notEnter: "not Enter",
    browserTip: "Your current browser may not work properly. Please use the latest version of Chrome browser to enter.",
    gotIt: "got it",
    browserLink: "Download Chrome browser",
    UserHasLeft: "User has left",
    notMic: "No voice call without mic",
    notCamera: "No video call without camera",
    joinBlacklistTip: "Are you sure you want to join the blacklist?",
    someoneSpeaking: "Someone's speaking",
    networkDisconnect: "Network disconnect",
    download: "Download",
    roomNumberText: "{0} appointments",

	peopleNumText: "in line：{0}",
    closeCameraAndMic: "You can't turn off the camera and Mic at the same time",


    offlineAppointment: 'To book',
    Booked: 'Booked',

    seeOfflineAppointments: "Check booking",

    appointments: "Check My Reservation",
    appointmentsotes: "Click to check who made the reservation ",
    appointmentltsotes: "Check the reservation list",
    unfollow: "Cancel",
    unfollownotes: "Click to cancel the reservation",
    makeSearch: "Search Name of Exhibition/Forum ",

    sendEndTip: "Remind to end",
    talkInvite: 'Negotiation invitation',
    talkPause: 'Suspend negotiations',
    talkRestart: 'Resume negotiations',
    invite: 'invite',

    seatManagementTip: "Sub Studio Booth",
    seatManagement: "Sub Studio Booth",
    queue: "In Queue",
    queuenotes: "Click to see who is in queue",
    ahead: "Reservation",
    newAhead: " ",
    present: "engaged",
    people: "people",

    alreadyHave: "Reservation：",
    // newAlreadyHave: "Reservation：",
    attend: "attendees",
    homePage: "Home Page",
    bookRecord: 'Reservation',

    Domestic1:'Liu Yu Zheng',
    Domestic2:'Ding Fang',
    Domestic3:'Angel Lee',
    Promotion1:'Candy Zhang',
    Support1:'Lucy Bee',

    localTime:'Local Time',

    //视频列表
    congratulationsTxt:'Congratulations',
    clickPlayInstructions:'Please click the play button to watch',

    //顶部导航添加表演标签
    perform:'SHOW',

    visitors:'Visitors',
    participants:'Participants',

   negotiation: 'negotiation',

   suggestSize: 'Recommended size ',


   MarketingPromotion: 'Marketing & Promotion',
   GuestsList: 'GuestsList',
   Description: 'Description',


   NotStarted: 'Not Started',
   InLine: 'In Chatting',
   newInLine: 'InLine',
   Finished: 'Finished',


   Calling: 'Call',
   GuestList: 'Guest List',
   GuestListnotes: 'Click to check the guest list',
   Exhibitors: 'Exhibitors',
   Sharelinks: 'Share the link',
   ShareTicket: 'Share Ticket',
   share: 'Share',
   shared: 'Shared',
   takeBack: 'TakeBack',
   takeBackTip: 'Are you sure you want to take back the ticket',


   CreateTime: 'Create Time',

   RegisterNow: 'Register Now!',


   OnlineExhibitorRegister: "Online Exhibitor Register",
   OnlineVisitorRegister: "Online Visitor Register",
   OfflineExhibitorList: "Offline Exhibitor List",
   OfflineExhibitiorRegistor: "Offline Exhibitior Registor",

   submit: 'Submit',
   newStudioName: 'Meeting Topic',
   newKeyWord: 'Business Key Words',


   endnegotiationMessage: 'Whether to end negotiations with current customers?',
   Soundcontrol:'Sound control',
   Cameracontrol: 'Camera control',

   Introductionch: 'Company Introduction',
   Introductionen: 'Company Introduction',
   Logo: 'Company Logo',



   Pencilnotes: 'Change the pencil size',
   Soundcontrolnotes: 'Turn the sound on/off',
   Cameracontrolnotes: 'Turn the camera on/off',
   Brushnotes: 'Remove the graffiti',
   Beginchattingnotes: 'Start',
   Sharethefilenotes: 'Upload and show the file to the visitors.',
   UploadDownloadnotes: 'Exhibitor upload the file， visitor download the file',
   liveEndnotes: 'Sub chatting Ended',
   liveExitnotes: 'Exit',
   liveSendnotes: 'Send',
   liveRefreshnotes: 'Refresh',
   liveRefresh: 'Refresh',
   uploadTips:"Upload picture, word,excel,ppt,mp4,mp3，size：less than 50M",
   livePeoPleBookednotes: 'Click "call" botton to put your prefered people(in reservation) in first place (in line)',
   livePeoPleBookedRefreshnotes: 'Click "refresh" button  refresh your reservation list',
   livePeoPleLinenotes: 'Click “call ”botton to select your prefered people',

   outTextMessage: 'Pls confirm whether you need to quit the stutio booth?',



   Schedule: 'Schedule',
   FullDay: 'Full Day',
   StartingTime: 'Starting time',
    EndTime: 'End Time',

    //直播间设备检测
    deviceTest: 'Device Testing',
    micControl: 'Mic control',
    cameraControl: 'Camera control',
    beginTalkTip: 'Click on the <img src="./imgs/kaishi.png"></img> button below to start',
    endTalkTipDetail: 'Your negotiation time is approaching, and you will be prompted to reserve your contact information',
    roomPausedTip: 'The meeting has been supspended by the exhibitor and  will get started soon.',
    canNotPauseTip: 'The negotiation in the live broadcasting room has not started yet and cannot be suspended',
    invitationUserTip: 'Are you sure you want to invite new visitor to continue the meeting? ',
    invitationXUserTip: 'Are you sure you want to invite users {x}',
    invitationSuccess: 'The invitation succeeded. The user has been notified to enter the live room',
    subscribeListCount: '${num} reserved',
    queueListCount: '${num} in line',
    noOneSrubscribed: 'No one has made an appointment yet~',
    noOneInQueue: 'No one has lined up yet~',

    //公告列表
   noticeList:'Notice List',
   noticeContent: 'Content',
   noticeDate: 'Date',
   noticeType: 'Type',
   noticeExhName: 'Exhibition',
   noticeRole:'Role',
   roomOutTitle: 'You are the only anchor in the live broadcasting room. After the negotiation, the live broadcasting room will be closed and all visitors will be kicked out of the live broadcasting room queue. Are you sure to end the negotiation?',

    // 设备检测
    deviceLink: 'Device connection',
    deviceAuthTip: 'Before device detection, please be sure to turn on the camera and microphone permissions to the current page',
    beginTest: 'Start detection',
    linkAgain: 'Reconnect',
    cameraSelect: 'Camera selection',
    seeSelfClearly: 'Can you see yourself clearly?',
    yes: 'YES',
    no: 'NO',
    speakerSelect: 'Speaker selection',
    turnHigh: 'Please turn up the volume of the device and click \nto play the audio below to try and click the audio to test',
    hearClearly: 'Can you hear the sound?',
    micSelect: 'Microphone selection',
    sayHello: 'Say \'hello\' to the microphone and try ~',
    canSeeSoundIconMove: 'Can you see the volume icon beating?',
    os: 'OS',
    browserVersion: 'Browser version',
    shareScreen: 'Screen sharing capability',
    netDelay: 'Network delay',
    uplinkQuality: 'Uplink network quality',
    downlinkQuality: 'Downlink network quality',
    testRemainTime: 'Test remaining time',
    seeTestReport: 'View test report',
    testReport: 'Test report',
    testAgain: 'Retest',
    registerAreaCh: 'Domestic',
    registerAreaEn: 'Overseas',
    codeError: "Incorrect verification code",
    testFinish: 'Complete the test',
    notice:'Notice:',
    specifyNotice:'Notice：',
    apply:'Sign up',
    signUpTip:'After registration, you can view the contact information',
    completeInfo:"Please fill in the complete information!",
    checkPassMistake:"The passwords entered twice are inconsistent!",
    passMistake:"The password is too simple, please re-enter!",
    editeStudio:"Setting of the booth",
    click: 'Click',
    uploadLogo: 'Upload logo',
    attributable: 'Assigned users',
    deviceTest: 'Device Detection',
    perfectInfo:"Please improve your personal information",
    appointmentTime:"Reservation time",
    noApplyExhibition:"Tickets have not been sold yet. Please come back later.",
    exhibitionNotStarted:"Exhibition not started",
    broadcastTipOne:"Video files can only be played on the PC",
    broadcastTipTwo:"The maximum video file limit for file management is 50m",
    liveTip:"The current conversation is not finished. Pls end the current conversation if invite one new guest.",
    companyLogin:"company login",
    personalLogin:"personal login"
}
